var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-auto w-full overflow-auto no-scrollbar pb-10"},[_c('pipeline-opportunities',{staticClass:"bg-filters",attrs:{"mobile":true}}),_c('pipeline-sales',{attrs:{"mobile":true}}),_c('effectiveness-ratio',{attrs:{"isMobile":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }